import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header'
import Menu from './menu'
import GamesService from '../services/casinoGamesService'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import '../css/casino/index.css'
import '../css/casino/style.css'
import '../css/casino/responsive.css'
import CasinoCurrencyModal from './sub_components/casinoCurrencyModal';
import { casinoCurrencyList } from '../configs/casinoCurrencyList';
import * as authUtil from "../util/auth.util";
let oid = OPERATOR_ID.toLowerCase()

class Avaitor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            games: [],
            allGames: [],
            showPopup: false,
            operator: OPERATOR_ID,
            gameType: "new",
            gameCategory: "All",
            openGame: false,
            betGamesSrc: '',
            link: "",
            loader: true
        };
    }
    componentDidMount() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        if ((!!accData && Object.keys(accData).length > 0)) {
            const self = this;
            this.setState({ showPopup: casinoCurrencyList["BETGAMES"].currencyEquals === '1' ? false : true }, () => {
                const operator = this.state.operator
                let token = JSON.parse(localStorage.getItem('userAuthDetail'))
                let rl = token?.role
                token = !!token ? token.token : null
                if (!!operator && !!token && rl !== 'DemoClient') {
                    window.localStorage.setItem("operator", operator);
                    window.localStorage.setItem("token", token);
                    GamesService.getIndividualGame(27).then((res) => {
                        if (!!res && !!res.data && !!res.data.url) {
                            self.setState({ betGamesSrc: res.data.url }, () => {
                                self.loadBetGames(res.data.url);
                            })

                        }
                        this.setState({ loader: false })
                    })
                }
            });
        }
    }
    componentWillUnmount() {
        if (!!document.getElementById("betGamesTvScrpt")) {
            document.getElementById("betGamesTvScrpt").remove();
        }
    }
    loadBetGames(betGamesSrc) {
        const urlparts = betGamesSrc.split('&');
        const clientUrl = urlparts[0].split('=')[1];//'https://integrations01-webiframe.betgames.tv';
        const serverurl = urlparts[1].split('=')[1];
        const token = urlparts[2].split('=')[1];
        const partner = urlparts[3].split('=')[1];
        const language = urlparts[4].split('=')[1];
        const timezone = urlparts[5].split('=')[1];
        const gmid = urlparts[6].split('=')[1];
        const script = document.createElement("script");
        script.type = 'text/javascript';
        script.src = `${clientUrl}/public/betgames.js?${Date.now()}`;
        script.async = true;
        script.id = "betGamesTvScrpt";
        script.onload = function () {
            let _bt = {};
            //"/?serverUrl=https://integrations01.betgames.tv&token=n657IpvhFmNaucLAiM57pTNkN4oJZV4N45iW5VlyB4&partner=bethubs_dev&language=en&timezone=0"
            _bt['containerId'] = 'dvBetGamesIntegration';
            _bt['clientUrl'] = clientUrl;
            _bt['apiUrl'] = serverurl;//'https://betgames-dev.clubcasino.io/operator';//serverurl;
            _bt['partnerCode'] = partner;
            _bt['partnerToken'] = token;
            _bt['language'] = language;
            _bt['timezone'] = timezone;
            _bt['gameId'] = gmid;
            
            window['BetGames'].setup(_bt);
            // BetGames.frame(_bt); window.BetGames.setup
        }
        if (!!document.head) {
            document.head.appendChild(script);
        }
    }
    hideCurrencyPopup() {
        this.setState({ showPopup: false });
    }
    render() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        const profData = JSON.parse(localStorage.getItem("profData"));
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />
                    <div className="col-center1 markets">
                        <section>
                        
                        {!(!!accData && Object.keys(accData).length > 0) &&
                            <div className="sub_path center-box"><p>Casino</p></div>
                        }
                            <div className={`container-fluid casino-content-page ${this.state.operator}`} >
                                { (!!profData && profData.role !== 'DemoClient') && (!!accData && Object.keys(accData).length > 0) ?
                                    <>
                                        {this.state.betGamesSrc === '' ?
                                            <>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="loader-bg" style={{ display: this.state.loader ? "flex" : "none" }}>
                                                            <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/loader.gif"} className={`${this.state.loader ? "loader-image-active" : "loader-image-active"}`} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <div id='dvBetGamesIntegration' className="row">
                                            </div>
                                        }
                                    </>
                                    :
                                    <>
                                        <div className='row mt-4 mb-2 featured-game1 casino-game livecasino-container-login'>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 livecasino-item slots__item " onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/betgames/Andar-Bahar.webp" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite"></div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Andar Bahar</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/betgames/Baccarat-9.webp" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite"></div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Baccarat 9</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/betgames/Bet-On-Poker.webp" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite"></div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Bet On Poker</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/betgames/Dice-Duel.webp" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite"></div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Dice Duel</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/betgames/Lucky-5.webp" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite"></div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Lucky 5</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/betgames/Lucky-6.webp" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite"></div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Lucky 6</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/betgames/Lucky-7.webp" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite"></div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Lucky 7</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/betgames/Poker-6.webp" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite"></div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Poker 6</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/betgames/Rock-On-Scissors.webp" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite"></div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Rock On Scissors</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/betgames/Speedy-7.webp" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite"></div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Speedy 7</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/betgames/War-Of-Bets.webp" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite"></div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">War Of Bets</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/betgames/Wheel-Of-Fortune.webp" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite"></div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Wheel Of Fortune</div> */}
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </section>
                    </div>
                    {this.state.showPopup && (!!accData && Object.keys(accData).length > 0) && <>
                        <CasinoCurrencyModal currencyEquals={casinoCurrencyList["BETGAMES"].currencyEquals} fileNM={"casinopoint"} hidePopup={() => { this.hideCurrencyPopup() }} />
                        {/* <div id="marketbetspopup" className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                            <div className="modal-dialog modal-sm modal-dialog-centered encasino">
                                <div className="modal-content">
                                    {/* <div className="modal-header">
                                        <h5 className="modal-title mt-0" id="myModalLabel">LIVE CASINO INFO</h5><button onClick={() => { this.setState({ showPopup: false }) }} type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                    </div> *}
                                    <div className="modal-body engcasinomodalbgimg">
                                       
                                    <button onClick={() => { this.setState({ showPopup: false }) }} type="button" className="close text-white ecasinobtnclose" data-dismiss="modal" aria-hidden="true">×</button>
                                            <img alt="" src={`${BASE_IMAGE_PATH}/casino/banner/images/new-popup.png`} className="img-fluid" />
                                        <button type="button" className='virtual-close-btn' onClick={() => { this.setState({ showPopup: false }) }} data-dismiss="modal">&nbsp;</button>

                                    </div>
                                    {/* <div className="modal-footer">
                                        <button type="button" onClick={() => { this.setState({ showPopup: false }) }} className="btn btn-danger waves-effect mx-auto" data-dismiss="modal">Continue</button>
                                    </div> *}
                                </div>
                            </div>
                            <div className="modal-backdrop fade show" onClick={() => { }}></div>
                        </div> */}
                    </>}
                </div>
            </body>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Avaitor);